<template>
  <component :is="currentRuleComponent" />
</template>

<script>
import RuleGold from './rule/ruleGold.vue'
import RuleTiger from './rule/ruleTiger.vue'
import themeMixin from '@/mixins/themeMixin'

export default {
  components: {
    RuleGold,
    RuleTiger
  },
  mixins: [themeMixin],
  computed: {
    currentRuleComponent() {
      switch (this.currentTheme) {
        case 'theme_tiger':
          return 'RuleTiger'
        case 'theme_gold':
        default:
          return 'RuleGold'
      }
    }
  }
}
</script>
